import { Fragment } from 'react';

import cross from '~/assets/icons/cross.svg';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { ShopBalance } from '~/components/ui/ShopBalance';
import { Text } from '~/components/ui/Text';
import { rage } from '~/rage';
import { WalletType } from '~/shared';
import gobbler from '../../assets/images/gobbler.svg';
import {
	StyledContainer,
	StyledDivider,
	StyledLeftContainer,
	StyledRightContainer,
} from './Head.styled';

const Head: React.FC = () => {
	return (
		<Fragment>
			<StyledContainer>
				<StyledLeftContainer>
					<img src={gobbler} />
					<Text>
						Лицензионный центр
						<br />
						штата Сан Андрес
					</Text>
				</StyledLeftContainer>
				<StyledRightContainer>
					<ShopBalance walletTypes={[WalletType.Cash]} transparent />
					<Button
						height={ButtonHeight.Height40}
						color={ButtonColors.Default}
						onClick={() => rage.drivingSchool.exit()}
						style={{
							width: '40px',
						}}
					>
						<img src={cross} width={20} height={20} />
					</Button>
				</StyledRightContainer>
			</StyledContainer>
			<StyledDivider />
		</Fragment>
	);
};

export { Head };
